import { v4 as uuidv4 } from 'uuid';
import { Injectable } from '@angular/core';
import { getCookie, setCookie, VISITOR_COOKIE_NAME, VISIT_COOKIE_NAME, NEVER_EXPIRE } from '../util/cookie';

const HALF_DAY = 0.5;

function initVisitor(): string {
  let id = getCookie(VISITOR_COOKIE_NAME);
  if (id) return id;

  id = 'VSTR-' + uuidv4();
  setCookie(VISITOR_COOKIE_NAME, id, NEVER_EXPIRE);
  return id;
}

function initVisit(): string {
  let id = getCookie(VISIT_COOKIE_NAME);
  if (id) return id;

  id = 'VST-' + uuidv4();
  setCookie(VISIT_COOKIE_NAME, id, HALF_DAY);
  return id;
}

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private visitorId: string | null = null;
  private visitId: string | null = null;

  getVisit(): { visitorId: string; visitId: string } {
    if (!this.visitorId) this.visitorId = initVisitor();
    if (!this.visitId) this.visitId = initVisit();
    return { visitorId: this.visitorId, visitId: this.visitId };
  }
}
